import '@beehive/components/dist/purple.css';
import App from 'containers/App';
import { getUserInfo, getSuppliersList } from 'modules/actions/account';
import configureStore from 'modules/store';
import * as qs from 'querystring';
import React, { ReactElement } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import addIntlLocalData from './addIntlLocalData';
import { showAlert } from 'utils';
import { setSType, scout } from '@mpc/common/src/utils';
import {dainit, daLogin, isDevOrTest} from '@mpc/common/src/utils/datracker';

// 引入bedrock全局样式
import '@bedrock/components/lib/styles/base.less';
import './index.less';
import './styles/bedrock/theme.less';
import './styles/index.less';
import { waterMark } from 'utils';
import _ from 'lodash';
import {versionMonitorByHash} from '@mpc/common/src/utils';
import PxToRemWrapper from "@mpc/common/src/features/PxToRemWrapper";
import { Theme } from '@bedrock/components';

const store = configureStore();
const querystring = location.search ? location.search.slice(1) : '';
const querystringInfo = qs.parse(querystring);
addIntlLocalData();

setSType('outer');

// 监听版本更新
versionMonitorByHash();

let isLogin = false

export const render = async (oldRender: () => void) => {
  await store
    .dispatch(getUserInfo(querystringInfo))
    .then((result: any) => {
      const init = () => {
        const userMail = _.get(result, ['data', 'email']);
        const userName = _.get(result, ['data', 'name']);

        scout({ appId: isDevOrTest() ? 'cb290332' : '8bf166ba', userName: `${userMail}` });
        dainit();
        daLogin(userMail);

        if (result.res_code !== -1) {
          waterMark(result.data);
        }
        
        isLogin = result.res_code === 1
      };
      if (result.res_code === 1) {
        store.dispatch(getSuppliersList());
      }
      init();
    })
    .catch((error: any) => {
      showAlert({ type: 'error', message: '用户未登录！' });
      console.log(error);
    });

  oldRender()
}

export function rootContainer(container: ReactElement) {
  return (
    <PxToRemWrapper>
      <Provider store={store}>
          <HashRouter>
            <Theme
              type={"mpc-purple"}
            >
              <App isLogin={isLogin} />
            </Theme>
          </HashRouter>
      </Provider>
    </PxToRemWrapper>
  );
}